import React, { Component, Fragment } from "react";
import {
  Row, Card, CardTitle, Form, Label, Input, Button,
  ModalHeader, ModalFooter, Modal, ModalBody, Tooltip, CustomInput
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../redux/actions";
import { AxiosPublicAPI } from '../../helpers/AxiosAPI';
import { postAPI_Verify_User, postAPI_Signup_User } from '../../constants/APIs';
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx } from "../../components/common/CustomBootstrap";
import queryString from 'query-string';
import PasswordStrengthBar from 'react-password-strength-bar';

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      firstname: '',
      lastname: '',
      password: '',
      creator: "dashboard",
      acceptTermsAndCondition: false,
      showTermsAndCondition: false,      
      success: false,
      isShow: false,
      message: '',
      tooltip: false,
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search)
    console.log(values);
    let data = { data: values.data };
    //  let data = { data: '0NiGF6C1xZBMmcBKNYAHS9BIj0xiavhLqxcVIc171ZcbW/SGhZ9WJLfc/YArjeWrdscqFBgUETavWKanZLfsafTGEpkq+oSRYzCUvAFxDZ+tT+NGk2o+NFCIY1BzH3/p+aGb9HAOwiew35OUMR+Fyw==' };
    AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_Verify_User}`,
      data: data
    }).then(
      res => {
        if (res.data.role === "Admin") {
          this.setState({ acceptTermsAndCondition: false });
          this.setState({ showTermsAndCondition: true });          
        }
        else {
          this.setState({ acceptTermsAndCondition: true });
          this.setState({ showTermsAndCondition: false });     
        }
        this.setState({ id: res.data.id });
      },
      error => {
        console.log('eee.data', error.data);
      }
    );
  }

  handleChangeFirstName = name => {
    this.setState({
      firstname: name.target.value,
    });
  };

  handleChangeLastName = name => {
    this.setState({
      lastname: name.target.value,
    });
  };

  handleChangePassword = password => {
    this.setState({
      password: password.target.value,
    });
  };

  handleTermsAndCondition = e => {
    this.setState({
      acceptTermsAndCondition: e.target.checked,
    });
  };

  onUserRegister() {
    
    let data = {
      id: this.state.id,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      password: this.state.password,
      creator: "dashboard"
    }

    var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (this.state.password.length >= 8 && this.state.password.length <= 16 &&
      /(?=.*[A-Z])/.test(this.state.password) && /(?=.*[a-z])/.test(this.state.password) &&
      /(?=.*[0-9])/.test(this.state.password) && /(?=.*[@#$%^&-+=()])/.test(this.state.password)) {

      if (this.state.acceptTermsAndCondition === true) {
        AxiosPublicAPI({
          method: 'post',
          url: `${postAPI_Signup_User}`,
          data: data
        }).then(
          res => {
            this.setState({
              success: true,
            });
          },
          error => {
            console.log('eee.data', error.data);
          }
        );
      } else {
        this.setState({ message: 'Please accept aiva terms and conditions.' })
        this.setState({ isShow: true });
      }
    }
    else{
      this.setState({ message: 'Password length must be in between of 8 to 16 characters and its must have 1 upper case, 1 lower case, 1 digit and 1 special characters.' })
      this.setState({ isShow: true });
    }
  }



  render() {
    return (
      <Fragment>
        <Row className="h-100">
          <Colxx xxs="12" md="10" className="mx-auto my-auto">
            <Card className="auth-card">
              <div className="position-relative image-side ">
                <p className="text-white h2 text-large mb-2">Welcome to </p>
                <p className="text-white text-xlarge  h2 mb-2">the world of <strong>aiva</strong> </p>
                <p className="text-white h2 text-large mb-2">a voucher distribution network for savvy businesses! </p>
                <p className="white mb-0">
                </p>
                <br />
                <br />
                <p className="text-white" > <a href="https://getaiva.com/privacy-policy/" target="_blank" className="text-white" style={{ textDecoration: 'underline' }}>Privacy Policy</a></p>
              </div>
              {!this.state.success && (<div className="form-side">
                <NavLink to={`/`} className="white">
                  <span className="logo-single"> <img src="/static/media/aiva_logo_large.f89ed2fe.jpg" width="200" /> </span>
                </NavLink>
                <CardTitle className="mb-4">
                  <IntlMessages id="user.register" />
                </CardTitle>
                <div className='m-2'>
                  <h6>Your password must contain </h6>
                  <ul className='ml-3'>
                    <li className='mb-2'>Atleast 8 Characters (16 Maximum).</li>
                    <li className='mb-2'>Atleast one upper case letter.</li>
                    <li className='mb-2'>Atleast one lower case letter.</li>
                    <li className='mb-2'>Atleast one number.</li>
                    <li className='mb-2'>Atleast one of the following symbols (?=.*[@#$%^&-+=()]).</li>
                  </ul>
                </div>
                <Form>
                  <Label className="form-group has-float-label mb-4">
                    <Input type="firstname" onChange={this.handleChangeFirstName} />
                    <IntlMessages id="user.firstname" />
                  </Label>
                  <Label className="form-group has-float-label mb-4">
                    <Input type="lastname" onChange={this.handleChangeLastName} />
                    <IntlMessages id="user.lastname" />
                  </Label>
                  {/* <Label className="form-group has-float-label mb-4">
                  <Input type="email" defaultValue={this.state.email} />
                  <IntlMessages id="user.email" />
                </Label> */}
                  <Label className="form-group has-float-label" id="Tooltip">
                    <Input type="password" onChange={this.handleChangePassword} />
                    <IntlMessages
                      id="user.password"
                    />
                  </Label>
                  <Tooltip
                    placement={'right'}
                    isOpen={this.state.tooltip}
                    target={"Tooltip"}
                    toggle={() => this.setState(prevState => ({
                      tooltip: !prevState.tooltip
                    }))}
                  >
                    <p className='text-start' style={{ color: `${(this.state.password.length >= 8 && this.state.password.length <= 16) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Be 8 to 16 characters long</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[A-Z])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one upper case character</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[a-z])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one lower case character</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[0-9])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one number</span></p>
                    <p className='text-start' style={{ color: `${/(?=.*[@#$%^&-+=()])/.test(this.state.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one special character</span></p>
                  </Tooltip>
                  {this.state.password !== '' && <div className=""><PasswordStrengthBar
                    password={this.state.password}></PasswordStrengthBar>
                  </div>}
                  {this.state.showTermsAndCondition === true &&
                  <CustomInput
                    key={'acceptTermsAndCondition'}
                    type="checkbox"
                    onChange={this.handleTermsAndCondition}
                    checked={this.state.acceptTermsAndCondition}
                    label={
                      <label>
                        I agree to{' '}
                        <a
                          target="_blank"
                          href="https://getaiva.com/terms-of-service"
                          style={{ textDecoration: 'underline' }}
                        >
                          {' '}<strong>aiva</strong> Merchant Terms of Service
                        </a>
                      </label>}
                  >
                  </CustomInput>}
                  <div className="d-flex justify-content-end align-items-center mt-4">
                    <Button
                      color="primary"
                      className="btn-shadow"
                      size="lg"
                      onClick={() => this.onUserRegister()}
                    >
                      <IntlMessages id="user.register-button" />
                    </Button>
                  </div>

                </Form>
              </div>)}
              {this.state.success && (<div className="form-side">
                <NavLink to={`/`} className="white">
                  <span className="logo-single"> <img src="/assets/img/Bmb-logo.jpg" width="150" height="100" /> </span>
                </NavLink>
                <CardTitle className="mb-4">
                  Your account is created successfully. Now you can login to dashboard.
                  <NavLink to="#" style={{ padding: '0px', marginLeft: '5px' }} onClick={e => window.location.href = 'https://app.getaiva.com'} className="btn btn-link btn-empty btn-lg active">
                    CLICK HERE
                    <i className="simple-icon-arrow-right" />
                  </NavLink>


                </CardTitle>
              </div>)}
            </Card>
          </Colxx>
        </Row>
        <Modal isOpen={this.state.isShow} toggle={() => this.setState({ isShow: !this.state.isShow })}>
          <ModalHeader toggle={() => this.setState({ isShow: !this.state.isShow })}>
            Password
          </ModalHeader>
          <ModalBody>
            <h6 className="m--2">
              {this.state.message}
            </h6>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => this.setState({ isShow: !this.state.isShow })}>Close</Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    registerUser
  }
)(Register);
